import React from 'react';
import { toast } from 'react-toastify';
import { createIntl, createIntlCache, IntlShape } from 'react-intl';

import ToastType from '../constants/toastTypes';
import isOmpPlatform from '../utils/isOmpPlatform';
import messages from '../../assets/messages';
import renderLocale from './renderLocale';
import GlobalEnglishCanada from '../../assets/locale/globalFederated/en-CA';
import GlobalFrenchCanada from '../../assets/locale/globalFederated/fr-CA';
import mergeMessages from './mergeIntlMessages';
import ErrorService from '../../services/ErrorService';

let locale;
let overridingMessages;
let intl: IntlShape;
let mergedMessages;

if (isOmpPlatform()) {
  locale = renderLocale();
  overridingMessages = {
    'en-CA': GlobalEnglishCanada,
    'fr-CA': GlobalFrenchCanada
  };
  mergedMessages = mergeMessages(overridingMessages, messages);

  intl = createIntl(
    { locale, messages: mergedMessages[locale] },
    createIntlCache()
  );
}

const mapVariant = variant => {
  switch (variant) {
    case 'information':
      return 'neutral';
    default:
      return variant;
  }
};

const dispatchOmpToast = (node: React.ReactElement) => {
  const messageId = node?.props?.messages?.[0]?.props?.id;
  const values = node?.props?.messages?.[0]?.props?.values;
  const toastType = node?.props?.variant;
  let message;

  if (messageId) {
    try {
      message = intl.formatMessage({ id: messageId }, values);
    } catch (e) {
      ErrorService.trackError(e);
      return;
    }
  } else {
    message = node?.props?.messages?.[0];
  }

  window.document.dispatchEvent(
    new CustomEvent('mfe_toast_event', {
      detail: {
        message,
        variant: mapVariant(toastType)
      },
      bubbles: true
    })
  );
};

const TRToast = (children: React.ReactElement) => {
  if (isOmpPlatform()) {
    dispatchOmpToast(children);
  } else {
    toast(children, { containerId: ToastType.MAIN });
  }
};

export default TRToast;
